import gql from "graphql-tag";

export const GET_PROGRAMS = gql`
  query getPrograms($search: JSON!) {
    getPrograms(search: $search) {
      results {
        nid
        title
        langcode
        field_reference_combine_programs
        field_short_description
        field_weight_for_search
        field_weight_per_degree_nested
        field_studying_year_number
        mamta_title
        field_learning_aspect
        field_interest_area
        field_faculty_mamta
        field_faculty_mamta_1
        field_degree_type
        field_comments
        field_semester
        field_external_department_id
        field_mamta_programs
        field_plain_id_programs
        field_registration_comments
        field_plain_faculty_id
        field_short_name
        type
        body
        field_weight_for_faculty_nested
        field_faculty_nid
        field_bi_interested_number
        field_bi_degree_number
        field_bi_faculty_number
        field_bi_degree_description
        field_bi_interested_description
        field_bi_faculty_description
      }
    }
  }
`;
export const GET_PROGRAMS_BY_IDS_AND_LANGS = gql`
  query getProgramsByIdsAndLangs($heNids: [Int!],$enNids: [Int!]) {
    getProgramsByIdsAndLangs(heNids: $heNids, enNids: $enNids) {
      results {
        nid
        title
        langcode
        field_reference_combine_programs
        field_short_description
        field_weight_for_search
        field_weight_per_degree_nested
        field_studying_year_number
        mamta_title
        field_learning_aspect
        field_interest_area
        field_faculty_mamta
        field_faculty_mamta_1
        field_degree_type
        field_comments
        field_semester
        field_external_department_id
        field_mamta_programs
        field_plain_id_programs
        field_registration_comments
        field_plain_faculty_id
        field_short_name
      }
    }
  }
`;

export const GET_PROGRAM_BY_ID_AND_LANG = gql`
  query getProgramByIdAndLang($nid: Int!, $langcode: String!) {
    getProgramByIdAndLang(nid: $nid, langcode: $langcode) {
      nid
      title
      langcode
      field_reference_combine_programs
      field_short_description
      field_weight_for_search
      field_weight_per_degree_nested
      field_studying_year_number
      mamta_title
      field_learning_aspect
      field_interest_area
      field_faculty_mamta
      field_faculty_mamta_1
      field_degree_type
      field_comments
      field_semester
      field_external_department_id
      field_mamta_programs
      field_plain_id_programs
      field_registration_comments
      field_plain_faculty_id
      field_short_name
      type
      body
      field_weight_for_faculty_nested
      field_faculty_nid
      field_bi_interested_number
      field_bi_degree_number
      field_bi_faculty_number
      field_bi_degree_description
      field_bi_interested_description
      field_bi_faculty_description
    }
  }
`;

export const GET_DEGREES_OPTIONS = gql`
  query getDegreesOptions($search: JSON!) {
    getDegreesOptions(search: $search) {
        name
    }
  }
`;
export  const GET_PROGRAM_CONFIGURATION= gql` 
 query getProgramConfiguration {
  getProgramConfiguration {
    dates
  }
}
`;